<template>
  <div :class="css">
    <hero-homepage-gallery-v1
      v-if="version === '1_0'"
      :desktop-sizes="desktopSizes"
      :debug="debug"
      :translations="translations"
      :items="items"
      :mobile-sizes="mobileSizes"
      @update="updateOpacity"
    />

    <hero-homepage-gallery-v2
      v-else
      :desktop-sizes="desktopSizes"
      :debug="debug"
      :translations="translations"
      :items="items"
      :mobile-sizes="mobileSizes"
      :autoplay="autoplay"
      @update="updateOpacity"
    />

    <hero-homepage-debug
      :buttons="debugButtons"
      :debug="debug"
      :debug-enabled="debugEnabled"
      :items="debugItems"
      @click="toggleDebug"
    />

  </div>
</template>

<script lang="javascript">
import {mobileBreakpoint} from "Assets/js/components/size-checker";
import heroHomepageDebug from "./heroHomepageDebug.vue";
import HeroHomepageGalleryV1 from "./heroHomepageGalleryV1.vue";
import HeroHomepageGalleryV2 from "./heroHomepageGalleryV2.vue";

const DEFAULT_ANIMATION = 'fade';

export default {
  name: "heroHomepage",
  components: {
    HeroHomepageGalleryV1,
    HeroHomepageGalleryV2,
    heroHomepageDebug,
  },
  data() {
    return {
      items: [],
      currentItemIndex: -1,
      currentItem: {},
      nextItem: {},
      translations: {},
      firstItem: true,
      block: null,
      autoplay: false,
      classList: [],
      canStopAnimation: true,
      debug: false, // Change to enable/disable debug mode
      debugEnabled: false, // Change to enable/disable debug panels
      debugData: {},
      isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
      modules: [],
      block_version: "1_0",
    };
  },
  beforeMount() {
    this.block = this.$parent.block;
    this.items = JSON.parse(this.$parent.items) || [];
    this.autoplay = this.$parent.autoplay === '1';
    this.translations = JSON.parse(this.$parent.translations) || {};
    this.block_version = JSON.parse(this.$parent.block_version) || "1_0";

    // Apply any override specified in the query string
    this.applyQueryString();

    // Initialise opacity
    this.updateOpacity(0);
  },
  methods: {
    debugChange(data) {
      this.debugData = data || {};
    },
    toggleDebug() {
      this.debug = !this.debug;
    },
    /**
     * Change desktop animation effect (grow | fade).
     */
    changeDesktopEffect() {
      this.desktopEffect = this.desktopEffect === 'fade' ? 'grow' : 'fade';
    },
    /**
     * Apply query string
     * debug=1                  Enable debug
     * animation=grow|fade      Override animation effect
     */
    applyQueryString() {
      const queryString = window.location.search.substring(1);

      if (queryString) {
        // Enable debug if query string contains debug=1
        if (queryString.match(/debug=1/gi)) {
          this.debugEnabled = true;
        }

        // Override animation effect, if query string contains animation=[grow|fade]
        const animation = queryString.match(/animation=([a-z]*)/gi);
        if (animation) {
          this.desktopEffect = animation[0].split('=')[1];
        }
      }
    },
    updateOpacity(itemIndex) {
      const item = this.items && this.items.length && this.items[itemIndex];
      if (item) {
        // Set CSS variable
        document.body.style.setProperty(
          '--hero-homepage-opacity',
          (item.colour_filter && item.colour_filter !== 'none' ? +item.colour_filter_opacity / 100 : 1) + ""
        );
      }
    }
  },
  computed: {
    version() {
      return this.block_version;
    },
    animationType() {
      // Valid types: grow, fade
      return this.desktopEffect || DEFAULT_ANIMATION;
    },
    css() {
      return [
        'hero-homepage__item',
        this.isSafari && 'hero-homepage__item--safari',
        'hero-homepage__animation-' + this.animationType,
      ].concat(this.classList || []);
    },
    desktopSizes() {
      const breakpoint = mobileBreakpoint();
      return '(min-width: 1440px) 1440px, (min-width: 1024px) 1024px, (min-width: ' + breakpoint + 'px) ' + breakpoint + 'px';
    },
    mobileSizes() {
      const breakpoint = mobileBreakpoint();
      return '(min-width: ' + breakpoint + 'px) ' + breakpoint + 'px, (min-width: 500px) 100vw, 250px';
    },
    debugItems() {
      const inject = [];
      for (let key in this.debugData) {
        if (this.debugData.hasOwnProperty(key)) {
          inject.push({key: key, value: this.debugData[key]})
        }
      }

      return [
        {classList: this.classList.join()},
        this.firstItem && 'firstItem' || 'nextItem',
        {animationType: this.animationType},
        {currentItemIndex: this.currentItemIndex},
        {opacity: getComputedStyle(document.body).getPropertyValue('--hero-homepage-opacity')},
      ].concat(inject);
    },
    debugButtons() {
      return [
        {
          label: this.debug ? 'Debug On' : 'Debug Off',
          click: this.toggleDebug
        },
        this.debugEnabled ? {
          label: "Change animation (" + this.desktopEffect + ")",
          click: this.changeDesktopEffect
        } : null
      ]
    },
  },
};
</script>

